module.exports = __webpack_public_path__ + "img/ic_swiper_arrow_left.c8234c29.svg";